<script setup lang="ts">
import SiteInformations from '../../../components/cards/site/informations.vue';
import SiteReference from '../../../components/cards/site/reference.vue';
import SiteWeather from '../../../components/cards/site/weather.vue';
</script>
<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <site-informations />
    <site-reference />
    <site-weather />
  </div>
</template>
